import { DocumentSubtitleSegmentV1 } from '@utils/types/editors/subtitles/subtitle.ts';
import CaptionSegment from '@components/editors/caption-editor/body/caption-segment.tsx';
import { UnpairedRowBadge } from '@components/editors/transcript-editor/split-view/unpaired-row-badge.tsx';
import {
  CAPTION_ROW_HEIGHT,
  type CaptionRowGroup
} from './pair-source-segment.ts';

interface Props {
  group: CaptionRowGroup;
  /** The translation's full segment list, for in-pane navigation. */
  segments: DocumentSubtitleSegmentV1[];
}

const noop = () => {};

/**
 * One split-view row in the translation pane (#2250): every translated
 * segment that belongs to the row's source segment, stacked. A source
 * with no translation gets a one-slot "no translation" marker so the
 * row still lines up with its source.
 */
export function TranslationRowGroup({ group, segments }: Props) {
  if (group.translations.length === 0) {
    return (
      <div
        className="flex items-center px-3"
        style={{ height: CAPTION_ROW_HEIGHT }}
      >
        <UnpairedRowBadge side="translation" />
      </div>
    );
  }
  return (
    <>
      {group.translations.map(({ segment, index }) => (
        <CaptionSegment
          key={`translation-${segment.id}-${segment.start}-${segment.stop}`}
          segment={segment}
          index={index}
          onWordOutOfView={noop}
          onWordInView={noop}
          filteredItems={segments}
          sourceSegment={group.source}
        />
      ))}
    </>
  );
}
